export default __webpack_public_path__ + "static/media/RAMKA.a451b8dc.png";